export default __webpack_public_path__ + "static/eac-favicon-758aa7c332c9443378e465f6262d3e70.png";